import { render } from "./BotaoOrcamentoCidadao.vue?vue&type=template&id=be7c7f90"
import script from "./BotaoOrcamentoCidadao.vue?vue&type=script&lang=js"
export * from "./BotaoOrcamentoCidadao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__